import { TextField, InputAdornment, Select, MenuItem } from '@material-ui/core';
import { schemeType } from '../../../../redux-store/types/newPurchase';
import { isAlphaNumeric } from '../../../../utils/constants';
type PurchaseInputFieldProps = {
    label?: string;
    value: any;
    showHelper?: boolean;
    handleChange: any;
    stateKey: string;
    uiKey?: string;
    maxLength?: number;
    minLength?: number;
    errorText?: string;
    handleTouch?: any;
    checkError?: (value: any) => boolean;
    handleError?: any;
    touched?: any;
};
export const PurchaseInputField = ({
    stateKey,
    handleChange,
    value,
    label,
    uiKey,
    touched,
    checkError = () => false,
    maxLength,
    showHelper,
    handleError,
    handleTouch,
    errorText,
}: PurchaseInputFieldProps) => {
    // const errPresent = (value: string) => checkError(value);
    return (
        <TextField
            label={label ? label : ''}
            id={`enter-${stateKey.toLowerCase()}`}
            placeholder={
                stateKey === API_KEYS.SUB_ARN || stateKey === API_KEYS.SUB_BROKER_CODE
                    ? `Optional`
                    : ''
            }
            variant="outlined"
            inputProps={stateKey === API_KEYS.AMOUNT ? { inputMode: 'numeric' } : undefined}
            InputProps={
                uiKey
                    ? stateKey === API_KEYS.RIA_CODE
                        ? {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Select
                                        onChange={(e) =>
                                            handleChange((prevState: schemeType) => ({
                                                ...prevState,
                                                riaFlag: e.target.value,
                                            }))
                                        }
                                        value={value.riaFlag}
                                    >
                                        <MenuItem value={UI_KEYS.RIA_CODE}>INA</MenuItem>
                                        <MenuItem value={UI_KEYS.INP}>INP</MenuItem>
                                    </Select>
                                </InputAdornment>
                            ),
                        }
                        : {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <p>
                                        {(!value[stateKey] && stateKey === API_KEYS.AMOUNT) ||
                                            stateKey === API_KEYS.SUB_BROKER_CODE
                                            ? ''
                                            : uiKey}
                                    </p>{' '}
                                </InputAdornment>
                            ),
                        }
                    : undefined
            }
            onBlur={(e) => {
                !!handleTouch
                    ? handleTouch((prevState: any) => {
                        return { ...prevState, [stateKey]: true };
                    })
                    : null;
            }}
            onFocus={(e) => {
                !!handleTouch
                    ? handleTouch((prevState: any) => {
                        return {
                            ...prevState,
                            [stateKey]: false,
                        };
                    })
                    : null;
            }}
            onChange={(e: any) => {
                if (
                    e.target.value.match(/^[0-9]*$/) ||
                    stateKey === API_KEYS.SUB_BROKER_CODE ||
                    stateKey === API_KEYS.ARN
                ) {
                    if (!!maxLength && e.target.value.length > maxLength) return;
                    if (!isAlphaNumeric(e.target.value)) return;
                    handleChange((prevState: schemeType) => {
                        return {
                            ...prevState,
                            [stateKey]: e.target.value,
                        };
                    });
                    !!handleError
                        ? handleError((prevState: any) => {
                            return {
                                ...prevState,
                                [stateKey]: checkError(e.target.value) || false,
                            };
                        })
                        : null;
                }
            }}
            value={!!value[stateKey] ? value[stateKey] : ''}
            error={!!touched?.[stateKey] && checkError(value[stateKey])}
            helperText={
                showHelper || (!!touched?.[stateKey] && checkError(value[stateKey]))
                    ? errorText
                    : ''
            }
        />
    );
};
export const consolidateErrors = (errorObject: any): boolean => {
    let errorValues = Object.values(errorObject) || [];
    return errorValues.reduce((acc: boolean, curr: any) => acc || curr, false);
};

export const calculateOrdinality = (index: number) => {
    let suffix = ['th', 'st', 'nd', 'rd'];
    let v = index % 100;
    return index + (suffix[(v - 20) % 10] || suffix[v] || suffix[0]);
};

export enum API_KEYS {
    ARN = 'distId',
    SUB_BROKER_CODE = 'subDist',
    SUB_ARN = 'subBrokerARN',
    AMOUNT = 'amount',
    EUI_NO = 'euin',
    EUI_FLAG = 'euinDeclarationFlag',
    RIA_CODE = 'riaCode',
}

export enum UI_KEYS {
    ARN = 'ARN-',
    SUB_BROKER_CODE = 'ARN-',
    SUB_ARN = 'ARN-',
    EUI_NO = 'E',
    RIA_CODE = 'INA',
    INP = 'INP',
}

export enum ERR_KEYS {
    EUI = 'eui_error',
}

export const getSipDays = (dayStringArray: Array<string>) => {
    let dayArray: Array<number> = [];
    let invalidDay = false;
    dayStringArray?.forEach((day: string) => {
        if (!!parseInt(day)) {
            dayArray.push(parseInt(day));
        } else {
            invalidDay = true;
        }
    });
    if (invalidDay || dayStringArray?.length === 0 || !dayStringArray) {
        dayArray = Array.from({ length: 28 }, (x, i) => i).map((_, index) => index + 1);
    }
    return dayArray;
};

export const getAge = (birthDateString: string | Date = new Date()) => {
    try {
        var today = new Date();
        var birthDate = new Date(birthDateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    } catch (e) {
        return 0;
    }
};
